import { Modal, notification } from 'antd';
import { useEffect, useRef } from 'react';
import pushRenderPdfTemplateConfig, { TemplateV2 } from '../../../api/pushRenderPdfTemplateConfig';
import { track } from '../../../tracking';
import { his } from '../../history';

const BlockHistoryEditHistory: React.FC<{
    docid: string;
    renderConfig: TemplateV2;
}> = ({ docid, renderConfig }) => {
    const config = useRef<TemplateV2>();
    config.current = renderConfig;

    useEffect(() => {
        const unblock = his.block((tx) => {
            if (tx.pathname === window.location.pathname) return;
            const t = Modal.confirm({
                title: (
                    <span className="flex mr-24 text-center">
                        Your changes are not saved. Do you want to save?
                    </span>
                ),
                content: (
                    <span className="flex text-14 mr-24 text-darwin-neutral-800 text-center">
                        All your current changes will be lost and cannot be recovered later.
                    </span>
                ),
                okText: 'Save',
                cancelText: "Don't Save",
                okButtonProps: { className: 'primary-btn font-lato rounded-4' },
                cancelButtonProps: { className: 'neutral-btn font-lato rounded-4' },
                visible: true,
                className: 'rounded-8 w-400',
                width: 470,
                keyboard: true,
                closable: true,
                onOk: async () => {
                    t.update({
                        okButtonProps: {
                            loading: true,
                            className: 'primary-btn font-lato cursor-pointer',
                        },
                    });

                    setTimeout(() => {
                        const el: HTMLDivElement = document.getElementsByClassName(
                            'ant-modal-wrap',
                        )[0] as HTMLDivElement;
                        el?.focus();
                    }, 200);

                    try {
                        config.current &&
                            (await pushRenderPdfTemplateConfig(docid, config.current));
                        notification.success({
                            message: 'New Template Saved!',
                            duration: 5,
                            placement: 'topRight',
                        });
                    } catch (e) {
                        notification.error({
                            message: (e as Error).message,
                            duration: 5,
                            placement: 'topRight',
                        });
                        track('ERROR', {
                            on: 'Push render pdf template config',
                            what: (e as Error).message,
                        });
                    }

                    unblock();

                    his.push({
                        pathname: tx.pathname,
                        state: tx.state,
                    });
                },
                onCancel: (args) => {
                    if (args?.triggerCancel) {
                        return;
                    }

                    unblock();

                    his.push({
                        pathname: tx.pathname,
                        state: tx.state,
                    });
                    track("EDIT_TEMPLATE_DON'T_SAVE");
                    t.destroy();
                    return;
                },
                bodyStyle: { padding: '24px' },
            });

            t.update({
                okButtonProps: { className: 'primary-btn font-lato cursor-pointer rounded-4' },
                cancelButtonProps: { className: 'neutral-btn font-lato cursor-pointer rounded-4' },
            });

            setTimeout(() => {
                const el: HTMLDivElement = document.getElementsByClassName(
                    'ant-modal-wrap',
                )[0] as HTMLDivElement;
                el?.focus();
            }, 200);

            return false;
        });

        return () => {
            unblock();
        };
    }, []);

    return null;
};

export default BlockHistoryEditHistory;
